const state = {
    unauthorizedRetried: false,
}

const getters = {
    unauthorizedRetried: state => state.unauthorizedRetried,
}

const mutations = {
    SET_UNAUTHORIZED_RETRIED(state, unauthorizedRetried) {
        state.unauthorizedRetried = unauthorizedRetried
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}
